<template>
  <b-card>
    <template v-slot:header>
      <span class="breadcrumbs"><b-link :to="{name: `project`}">Videos</b-link> / <b-link :to="{name: `${collection}`}">{{item ? item.name : ''}}</b-link> / Edit</span>
      <b-button size="sm" variant="danger float-right" @click="delete_item">Delete</b-button>
    </template>

    <Loading v-if="item === undefined"/>
    <Error v-else-if="item === null" code="404"></Error>
    <div v-else>

      <b-form @submit.stop.prevent="edit_item">
        <b-form-group label="Name:">
          <b-form-input v-model="item.name" required placeholder="Enter name"></b-form-input>
        </b-form-group>

        <b-form-group label="Overlay text:" >
          <b-form-input v-model="item.overlay_text" :readonly="profile.role !== 'admin'"></b-form-input>
        </b-form-group>

        <b-form-group v-if="project && project.presentation === 'website'">
          <b-input-group>
            <b-form-input placeholder='http://example.com' type='url' v-model='item.website' :readonly="profile.role !== 'admin'"></b-form-input>
            <b-input-group-append is-text>
              Force reload&nbsp;
              <b-form-checkbox v-model='item.website_force' :readonly="profile.role !== 'admin'"></b-form-checkbox>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <b-table-simple responsive bordered>
          <b-thead head-variant="light">
            <b-tr>
              <b-th>Variable</b-th>
              <b-th>Replace with</b-th>
            </b-tr>
          </b-thead>
          <b-tr v-for="(variable, index) in item.variables" v-bind:key="index">
            <b-td>{{variable.word}}</b-td>
            <b-td><b-input v-model="variable.replace_with" :readonly="profile.role !== 'admin'"/></b-td>
          </b-tr>
        </b-table-simple>

        <div>
          <h4>Quality control</h4>
          <b-form-group>
            <b-form-select v-model="item.quality_control_status" :options="['review', 'skip', 'pass', 'fail', 'bin']" />
          </b-form-group>
        </div>

        <h4>Video</h4>
        <VideoWaveform v-if="item.video_url" :video_url="item.video_url" class="mb-2"/>

        <div v-if="profile.role === 'admin' && project.name === 'First Video'">
          <b-button variant='danger' @click="mark_as_first_video_in_hubspot">Mark as first video in HubSpot</b-button>
        </div>

        <LoadingButton type="submit" variant='primary' :loading="is_saving" class="mr-2">Save</LoadingButton>
        <LoadingButton variant='warning' :loading="is_redoing" :disabled="item && item.status === 'pending'" @click="redo" v-if="profile.role === 'admin'">Redo</LoadingButton>

        <p class="muted mt-4"><small>Created {{item.created | datetime}}<br>Updated {{item.updated | datetime}}</small></p>
      </b-form>

    </div>
  </b-card>
</template>

<script>
import { db, storage, analytics } from '@/main.js'
import { required, minLength } from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"
import VideoWaveform from "@/components/VideoWaveform.vue"

import api from '@/lib/api.js'

export default {
  metaInfo: {title: 'Item edit'},
  mixins: [ItemMixin],
  components: {VideoWaveform},
  props: ['project'],
  firestore: function () {
    return {
      item: db.collection('project').doc(this.$route.params.id).collection(this.collection).doc(this.$route.params.item)
    }
  },
  validations: {
    item: {
    }
  },
  data() {
    return {
      is_redoing: false,
      uploading: false,
      param: 'item',
      collection: 'item'
    }
  },
  methods: {
    async redo() {
      this.is_redoing = true

      this.item.status = 'pending'
      this.item.background = null
      this.item.parts = null
      this.item.thumbnail_url = null
      this.item.video_url = null
      this.item.quality_control_status = null
      this.item.quality_control_updated = new Date()

      await this.edit_item()
      this.is_redoing = false
    },
    mark_as_first_video_in_hubspot() {
      let email = this.project.user.email
      let thumbnail_url = this.item.thumbnail_url || this.project.thumbnail_url
      analytics.identify(email, {email: email, first_video_thumbnail: thumbnail_url, first_video_link: this.item.video_player_url})
    },
    async on_complete(index, data) {
      this.uploading = true
      let snap = await storage.ref().child(`media/${db.collection('media').doc().id}.mp3`).put(data, {contentType: 'audio/mp3'})
      let url = await snap.ref.getDownloadURL()

      let result = await api.audio_to_text(url)
      let start = result.data.word_time_offsets[0].start
      let end = result.data.word_time_offsets[result.data.word_time_offsets.length-1].end
      this.item.variables[index].audio_url = result.data.audio_wav_url

      this.item.variables[index].start = start
      this.item.variables[index].end = end

      this.uploading = false
    },
    navigate_to_delete() {
      this.$router.push({name: `project`})
    }
  }
}
</script>

<style>

</style>
